// extracted by mini-css-extract-plugin
export default {"accountBg":"account_accountBg__7p7XH"};